import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AgentEmployeeService } from '../../services/agent-employee/agent-employee.service';
import { ChangeLogService } from '../../services/change_log/change-log.service';

@Component({
  selector: 'app-delete-agent-employee-dialog',
  templateUrl: './delete-agent-employee-dialog.component.html',
  styleUrls: ['./delete-agent-employee-dialog.component.css']
})
export class DeleteAgentEmployeeDialogComponent implements OnInit {

  errMsg;
  errFlag: boolean = false;
  logFormData: any;
  agentId: any;
  loginId: any;

  constructor(private agentEmployeeService: AgentEmployeeService,
              private changelogservice: ChangeLogService,
              public dialogRef: MatDialogRef<DeleteAgentEmployeeDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public employeeData: any) { }

  ngOnInit() {
    this.agentId = localStorage.getItem("AgentId");
    this.loginId = localStorage.getItem('loginID');
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  deleteDocument() {
    this.agentEmployeeService.deleteEmployees(this.employeeData, this.agentId).subscribe(res => {
      this.agentEmployeeService.load.next('success');
      this.onNoClick();
      this.logFormData = {
        "document_type": "Employee",
        "document_category": "Employee",
        "transaction_type": "Delete",
        "vendor_id": this.agentId,
        "employee_name": this.employeeData.employeeData.FirstName + " " + this.employeeData.employeeData.LastName
      };

      if (this.employeeData.employeeData.EmployeeStatus === 'Reject') {
          this.logFormData.transaction_type = 'Rejected';
      } else if (this.employeeData.employeeData.EmployeeStatus === 'Approved') {
          this.logFormData.transaction_type = 'Approved';
      }

      this.logFormData.modified_by = this.loginId;
      this.changelogservice.sendLogs(this.logFormData).subscribe(res => { }, err => {
        this.errMsg = err;
        this.errFlag = true;
      });
    }, err => {
      this.errMsg = err;
      this.errFlag = true;
    });
  }

  deleteEmployee(employeeData) {
    this.employeeData =  {employeeData: employeeData.data};
    this.agentId = localStorage.getItem("AgentId");
    this.loginId = localStorage.getItem('loginID');
    this.deleteDocument();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/delete-agent-employee-dialog/delete-agent-employee-dialog.component.ts